import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ObjectTypes } from "@common/enums/object-types";

export class DraftRecord extends Record {
    public iconClass: string = "icon-Text";
    public color: string = "#000";
    public background: string = "#fff";
    
    public initialize() {
        this.title = 'New Draft';
        this.text = '';
        this.type = ObjectTypes.DRAFT;
        super.initialize();

        this.setupRequiredFieldsGroups("Draft");
    }
    
    public get title(): string { return this.getAs<string>(PSTFieldNames.PSTWireTitle); }
    public set title(value: string) { this.set(PSTFieldNames.PSTWireTitle, value); }

    public get text(): string { return this.getAs<string>(PSTFieldNames.PSTRichText); }
    public set text(value: string) { this.set(PSTFieldNames.PSTRichText, value); }

    public get cleanText(): string { return this.getAs<string>(PSTFieldNames.PSTWireText); }
    public set cleanText(value: string) { this.set(PSTFieldNames.PSTWireText, value); }
}
